import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";

function Pagination(props) {
  const itemsPerPage = props.itemsPerpage;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    props.itemOffset(itemOffset);
    props.endOffset(endOffset);
    props.currentItems(props.items.slice(itemOffset, endOffset));
    props.clearSelectedItems([]);
    setPageCount(Math.ceil(props.items.length / itemsPerPage));
  }, [itemOffset, props.items]);

  useEffect(() => {
    setItemOffset(0);
    setCurrentPage(0);
  }, [props.items]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % props.items.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
  };

  return (
    <>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="<"
        renderOnZeroPageCount={null}
        breakClassName="page-item page-item-boxes"
        breakLinkClassName="page-link page-item-contents"
        marginPagesDisplayed={2}
        containerClassName="pagination justify-content-center"
        pageClassName="page-item page-item-boxes"
        pageLinkClassName="page-link page-item-contents"
        previousClassName="page-item page-item-boxes"
        previousLinkClassName="page-link page-item-contents"
        nextClassName="page-item page-item-boxes"
        nextLinkClassName="page-link page-item-contents"
        activeClassName="active active-item"
        forcePage={currentPage}
      />
    </>
  );
}

export default Pagination;
